(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product--default"]) return;
  try {
    
// update the price 
var updateprice = $('.product__price');
var updateaboveprice = $('.custom-update-price');

//  initialize the update price funtion
function updatePriceFromSelectedOption() {
    let selectedOption = $('input[name="purchaseType"]:checked');
    if (selectedOption.length) {
        let getHtml = selectedOption.parent().next().html();
        console.log('Price HTML:', getHtml);
        updateprice.html(getHtml);
        updateaboveprice.html(getHtml);
    } else {
        console.log('No option is selected');
    }
}
$(document).on('click', '.dynamic-variant-button, #purchaseTypeSubscription, #purchaseTypeOneTime', function () {
    updatePriceFromSelectedOption();
});
$(document).ready(function () {
    updatePriceFromSelectedOption();
});

// smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default jump behavior

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    });
  });

  // custom slider
  $('.custom-slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite: false,
    //centerMode: true,
    //centerPadding: '20px',
    speed: 1000,
    asNavFor: '.slider-thumbnail',
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
  });
  $('.slider-thumbnail').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.custom-slider-wrapper',
    dots: false,
    centerMode: false,
    centerPadding: '20px',
    focusOnSelect: true,
    infinite: false,
  });

  } catch(e) { console.error(e); }
})();
})();
